import * as PropTypes from "prop-types"
import styled from "styled-components"
import Typography from "components/styled/Typography"
import { useLocale, useT } from "react-polyglot-hooks"
import { sendEvent } from "scripts/GoogleAnalytics"

const Wrapper = styled.div`
  display: inline-block;
  width: 110px;
  border-radius: 100px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
  ${({ theme, active }) =>
    active
      ? `
    box-shadow: 0 6px 16px 0 rgba(11, 158, 217, 0.3);
    background: ${theme.colors.skyBlue};
  `
      : `
    background: ${theme.colors.silver};
  `}
`

const Text = styled(Typography)`
  line-height: 20px;
  white-space: nowrap;
  color: white;
`

const Swipe = styled.div`
  position: relative;
  width: 25px;
  height: 8px;
  border-radius: 100px;
  background: ${({ theme, active }) => (active ? "#2d71b4" : theme.colors.gray)};
  margin: 0 0 0 15px;
`

const Drag = styled.span`
  position: absolute;
  top: -8px;
  ${({ active }) => (active ? "right: -8px;" : "left: -8px;")}
  width: 24px;
  height: 24px;
  border-radius: 12px;
  box-shadow: 0 10px 20px 0 rgba(14, 62, 110, 0.33);
  background-color: #fff;
`

const Clickable = styled.a`
  cursor: pointer;
  padding: 8px 0;
`

export default function TaxToggle({ withoutTaxes, setWithoutTaxes, page, ...rest }) {
  const locale = useLocale()
  const t = useT()

  if (locale !== "es") return null

  const toggle = () => {
    sendEvent("TAX Switch", { event_category: page, event_label: withoutTaxes ? "with tax" : "without tax" })
    setWithoutTaxes(!withoutTaxes)
  }

  return (
    <Wrapper active={!withoutTaxes} {...rest}>
      <Text variant="small" weight="medium">
        {t(`common.${withoutTaxes ? "without" : "with"}_tax`)}
      </Text>
      <Clickable onClick={toggle}>
        <Swipe active={!withoutTaxes}>
          <Drag active={!withoutTaxes} />
        </Swipe>
      </Clickable>
    </Wrapper>
  )
}

TaxToggle.propTypes = {
  withoutTaxes: PropTypes.bool.isRequired,
  setWithoutTaxes: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired
}
